var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4063 0C7.75409 0 5.21055 1.05357 3.33518 2.92893C1.45982 4.8043 0.40625 7.34784 0.40625 10C0.40625 12.6522 1.45982 15.1957 3.33518 17.0711C5.21055 18.9464 7.75409 20 10.4063 20C13.0584 20 15.602 18.9464 17.4773 17.0711C19.3527 15.1957 20.4063 12.6522 20.4063 10C20.4063 7.34784 19.3527 4.8043 17.4773 2.92893C15.602 1.05357 13.0584 0 10.4063 0ZM7.54911 6.42857C7.35967 6.42857 7.17799 6.50383 7.04403 6.63778C6.91008 6.77174 6.83482 6.95342 6.83482 7.14286V12.8571C6.83482 13.0466 6.91008 13.2283 7.04403 13.3622C7.17799 13.4962 7.35967 13.5714 7.54911 13.5714H13.2634C13.4528 13.5714 13.6345 13.4962 13.7685 13.3622C13.9024 13.2283 13.9777 13.0466 13.9777 12.8571V7.14286C13.9777 6.95342 13.9024 6.77174 13.7685 6.63778C13.6345 6.50383 13.4528 6.42857 13.2634 6.42857H7.54911Z",
    fill: "#D70303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.622ab14593f595a92ee07144153574b5.svg";
export { ForwardRef as ReactComponent };